export const dateFormat = "YYYY-MM-DD";

export default interface DateParamValueConfig {
    type: "specific" | "relative";
    specificValue?: string;
    plus: boolean;
    difference?: number;
    differenceType: "days" | "weeks" | "months" | "years";
}
